<template>
  <div class="login_box clearfix" v-show="logintc">
    <div class="close" @click="loginsq">
      <img src="../assets/login/modal_close.png" />
    </div>
    <div class="jdt1">
      <el-carousel arrow="never" indicator-position="outside" height="480px">
        <el-carousel-item>
          <img src="../assets/login/login_a1.png" width="480" height="480" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/login/login_a2.png" width="480" height="480" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/login/login_a3.png" width="480" height="480" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/login/login_a4.png" width="480" height="480" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- jdt1 end -->
    <div class="login-right clearfix">
      <transition name="el-fade-in-linear">
        <div id="Avoid_close_login" class="Theight" v-show="Avoid_close_login">
          <ul class="login-nav">
            <li tag="li" class="side">
              <span>免密登录</span>
              <em></em>
            </li>
            <li @click="ptl">
              <span>密码登录</span>
              <em></em>
            </li>
          </ul>
          <h2 class="h2">手机号快速登录</h2>
          <h3 class="h3">欢迎进入考培在线网校，开启备考之旅。</h3>
          <el-form
            :model="avoid"
            :rules="rules"
            ref="avoid"
            class="demo-avoid"
            @submit.native.prevent
            :style="{ marginBottom: avoid.area_code == 1 ? '10px' : '50px' }"
          >
            <el-form-item prop="phone" :error="avoid.phoneErrorMsg">
              <el-input v-model="avoid.phone" placeholder="请输入手机号码">
                <el-select v-model="avoid.area_code" slot="prepend">
                  <el-option
                    :value="item.code"
                    :label="'+' + item.code"
                    :key="index"
                    v-for="(item, index) in countryCodeList"
                    >+{{ item.code + " " + item.cn }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="code"
              :inline="true"
              :class="{mb0:avoid.area_code == 1}"
            >
              <el-col :span="15">
                <el-input
                  v-model="avoid.code"
                  placeholder="请输入6位数的验证码"
                  maxlength="6"
                ></el-input>
              </el-col>
              <el-col class="line" :span="1">&nbsp;</el-col>
              <el-col :span="8">
                <el-button
                  @click="getCode('avoid')"
                  plain
                  class="button2"
                  :disabled="disabled_click_code"
                  >{{ getCodes }}</el-button
                >
              </el-col>
            </el-form-item>

            <div class="agree_view" v-if="avoid.area_code == 1">
              <p class="eng_text">
                Message and data rates may apply. Enter your phone number to
                receive one time passcode message to your phone from Shanghai
                Green Cucumber informationTechnology Co., Ltd. Msg freq may vary
                Reply “HELP” for help, Reply “STOP” to cancel
              </p>
              <el-form-item
                prop="isRead"
                :inline="true"
                class="mb0 my_checkbox eng_checkbox"
              >
                <el-checkbox v-model="avoid.isRead"
                  >I agree to comply with the
                  <a target="_blank" href="/agreement1_ysbh"
                    >《启德考培在线隐私保护协议》</a
                  >
                </el-checkbox>
                <span class="nav_agree">
                  &<a target="_blank" href="/agreement1_yhzx">《启德考培在线用户协议》</a
                  ></span
                >
              </el-form-item>
              <el-form-item
                prop="isAgree"
                :inline="true"
                class="mb0 my_checkbox eng_checkbox"
              >
                <el-checkbox v-model="avoid.isAgree"
                  >I agree to receive text message.
                </el-checkbox>
              </el-form-item>
            </div>
            <el-form-item
              :style="{
                marginBottom: avoid.area_code == 1 ? '10px' : '22px'
              }"
            >
              <el-button
                native-type="submit"
                @click="loginForm('avoid')"
                round
                class="button1"
                >登录
              </el-button>
            </el-form-item>
            <el-form-item prop="checked" :inline="true" class="mb0 my_checkbox">
              <el-checkbox v-model="avoid.checked">15天内自动登录</el-checkbox>
            </el-form-item>
          </el-form>
          <div tag="div" class="phome_div4">
            还没有账号？<a @click="registeredT">立即注册</a>
          </div>
          <!--          <div class="qt_login">-->
          <!--            <p><em></em><span>其他登录方式</span><em></em></p>-->
          <!--            <ul>-->
          <!--              <li tag="li" class="qq_login">-->
          <!--                <a-->
          <!--                  @mouseover="qq_login_m"-->
          <!--                  @mouseout="qq_login_v"-->
          <!--                  @click="qr_codeT(1)"-->
          <!--                  :class="{ hovers: qq_hover }"-->
          <!--                ></a>-->
          <!--              </li>-->
          <!--              <li tag="li" class="wx_login">-->
          <!--                <a-->
          <!--                  @mouseover="wx_login_m"-->
          <!--                  @mouseout="wx_login_v"-->
          <!--                  @click="qr_codeT(2)"-->
          <!--                  :class="{ hovers: wx_hover }"-->
          <!--                ></a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
        </div>
      </transition>
      <!-- Avoid_close_login end -->
      <transition name="el-fade-in-linear">
        <div
          id="Password_to_login"
          class="Theight psd_view"
          v-show="Password_to_login"
        >
          <ul class="login-nav">
            <li @click="acl">
              <span>免密登录</span>
              <em></em>
            </li>
            <li tag="li" class="side">
              <span>密码登录</span>
              <em></em>
            </li>
          </ul>
          <h2 class="h2">Hi，同学</h2>
          <h3 class="h3">欢迎进入考培在线网校，开启备考之旅。</h3>
          <el-form
            :model="passwords"
            :rules="rules"
            ref="passwords"
            class="demo-avoid"
            @submit.native.prevent
          >
            <el-form-item prop="phone">
              <el-input v-model="passwords.phone" placeholder="请输入手机号码">
                <el-select v-model="passwords.area_code" slot="prepend">
                  <el-option
                    :value="item.code"
                    :label="'+' + item.code"
                    :key="index"
                    v-for="(item, index) in countryCodeList"
                    >+{{ item.code + " " + item.cn }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" :inline="true">
              <el-input
                v-model="passwords.password"
                placeholder="请输入密码"
                show-password
                class="ipt_psd"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                native-type="submit"
                @click="passwordsForm('passwords')"
                round
                class="button1"
              >
                登录</el-button
              >
            </el-form-item>
            <div class="forget_psd">
              <a @click="retrieveT">忘记密码</a>
            </div>
            <el-form-item prop="checked" :inline="true" class="mb0 my_checkbox">
              <el-checkbox v-model="passwords.checked"
                >15天内自动登录</el-checkbox
              >
            </el-form-item>
          </el-form>
          <div tag="div" class="phome_div4">
            还没有账号？<a @click="registeredT">立即注册</a>
          </div>
        </div>
      </transition>
      <!-- Password_to_login end -->
      <transition name="el-fade-in-linear">
        <div
          id="Retrieve_password"
          class="Theight find_psd"
          v-show="findPsdStatus == 1"
        >
          <div class="icon_back" @click="back">
            <span class="back_img"></span> <span class="back_val">上一步</span>
          </div>
          <h2 class="h2">找回密码</h2>
          <el-form
            :model="retrieves"
            :rules="rules"
            ref="retrieves"
            class="demo-avoid"
          >
            <el-form-item prop="phone" :error="retrieves.phoneErrorMsg">
              <el-input v-model="retrieves.phone" placeholder="请输入手机号码">
                <el-select v-model="retrieves.area_code" slot="prepend">
                  <el-option
                    :value="item.code"
                    :label="'+' + item.code"
                    :key="index"
                    v-for="(item, index) in countryCodeList"
                    >+{{ item.code + " " + item.cn }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item class="mb0">
              <el-button
                @click="submitForm('retrieves')"
                round
                class="button_default"
                >发送验证码</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div
          id="Retrieve_password"
          class="Theight find_psd"
          v-show="findPsdStatus == 2"
        >
          <div class="icon_back" @click="back">
            <span class="back_img"></span> <span class="back_val">上一步</span>
          </div>
          <h2 class="h2">发送短信至</h2>
          <div class="my_ipone">
            <span>+{{ retrieves.area_code }}</span>
            <strong>{{ retrieves.phone }}</strong>
          </div>
          <div class="verificatio_code">
            <div class="verification-container">
              <input
                v-for="(code, index) in verificationCodes"
                :key="index"
                v-model="verificationCodes[index]"
                @input="handleInput(index, $event)"
                @keydown="handleKeyDown(index, $event)"
                maxlength="1"
                class="verification-input"
              />
            </div>
            <div class="code_count" v-if="yz_count">
              <span>{{ yz_count }}</span
              >秒后可重新获取验证码
            </div>
            <div
              class="code_count"
              v-else
              style="cursor: pointer;"
              @click="resetGet"
            >
              <span>重新获取验证码</span>
            </div>
          </div>
          <el-button
            :loading="disabledBtn"
            type="default"
            class="next_btn"
            @click="psdNext('retrieves')"
            >下一步</el-button
          >
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div
          id="Retrieve_password"
          class="Theight find_psd set_psd"
          v-show="findPsdStatus == 3"
        >
          <div class="icon_back" @click="back">
            <span class="back_img"></span> <span class="back_val">上一步</span>
          </div>
          <h2 class="h2">设置新的登录密码</h2>
          <div class="my_ipone">
            请输入6-20位的密码，区分大小写
          </div>
          <el-form
            :model="psdForm"
            :rules="rules"
            ref="psdForm"
            class="demo-avoid"
          >
            <el-form-item prop="password" :inline="true" class="mb0">
              <el-input
                v-model="psdForm.password"
                minlength="6"
                maxlength="20"
                placeholder="设置6-20位密码，区分大小写"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="againPassword" :inline="true" class="mb0">
              <el-input
                v-model="psdForm.againPassword"
                minlength="6"
                maxlength="20"
                placeholder="再次确认密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item class="mb0">
              <el-button
                :loading="disabledBtn"
                @click="resetPsd('psdForm')"
                class="button_default"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div class="Theight success_psd" v-if="findPsdStatus == 4">
          <div class="set_success">
            <img
              src="@/assets/login/set_psd_scuuess.png"
              class="success_icon"
              alt=""
            />
            <el-button class="back_login" @click="backLogin"
              >返回登录</el-button
            >
          </div>
        </div>
      </transition>
      <!-- Retrieve_password end -->
      <transition name="el-fade-in-linear">
        <div id="Phone_registered" class="Theight" v-show="Phone_registered">
          <div class="icon_back" @click="back">
            <span class="back_img"></span> <span class="back_val">上一步</span>
          </div>
          <h2 class="h2">手机号快速注册</h2>
          <h3 class="h3">快速注册，可获取新人福利哦！</h3>
          <el-form
            :model="registereds"
            :rules="rules"
            ref="registereds"
            class="demo-avoid"
          >
            <el-form-item prop="phone" :error="registereds.phoneErrorMsg">
              <el-input
                v-model="registereds.phone"
                placeholder="请输入手机号码"
              >
                <el-select v-model="registereds.area_code" slot="prepend">
                  <el-option
                    :value="item.code"
                    :label="'+' + item.code"
                    :key="index"
                    v-for="(item, index) in countryCodeList"
                    >+{{ item.code + " " + item.cn }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="code" :inline="true">
              <el-col :span="15">
                <el-input
                  v-model="registereds.code"
                  placeholder="请输入6位数的验证码"
                  maxlength="6"
                ></el-input>
              </el-col>
              <el-col class="line" :span="1">&nbsp;</el-col>
              <el-col :span="8">
                <el-button
                  @click="getCode('registereds')"
                  :disabled="disabled_click_code"
                  plain
                  class="button2"
                  >{{ getCodes }}</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item prop="password" :inline="true">
              <el-input
                v-model="registereds.password"
                minlength="6"
                maxlength="20"
                placeholder="设置6-20位密码，区分大小写"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="againPassword" :inline="true">
              <el-input
                v-model="registereds.againPassword"
                minlength="6"
                maxlength="20"
                placeholder="确认密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="submitphone('registereds')"
                round
                class="registration_btn"
                :disabled="!registereds.checked"
                >注册
              </el-button>
            </el-form-item>
            <el-form-item prop="checked" class="mb0 my_checkbox">
              <el-checkbox v-model="registereds.checked"
                >我已阅读并接受</el-checkbox
              >
              <router-link target="_blank" :to="{ path: '/agreement1_ysbh' }"
                >《启德考培在线用户隐私保护政策》</router-link
              >
              <router-link target="_blank" :to="{ path: '/agreement1_yhzx' }"
                >《启德考培在线用户注册协议》</router-link
              >
            </el-form-item>
          </el-form>
        </div>
      </transition>
      <!-- registered_password end -->
      <transition name="el-fade-in-linear">
        <div id="Qr_code" class="Theight" v-show="Qr_code">
          <div class="icon_back" @click="back">
            <span class="back_img"></span> <span class="back_val">上一步</span>
          </div>
          <h2 class="h2">微信扫码登录</h2>
          <h3 class="h3">请使用考培在线移动端扫描二维码</h3>
          <el-form
            :model="qr_code"
            :rules="rules"
            ref="qr_code"
            class="demo-avoid"
          >
            <img
              src="../assets/publicClass/erwm.png"
              width="188"
              alt="微信"
              title="微信"
              v-if="ewm"
            />
            <img
              src="../assets/publicClass/erwm.png"
              width="188"
              alt="QQ"
              title="QQ"
              v-else
            />
            <el-form-item prop="checked" class="mb0 my_checkbox">
              <el-checkbox v-model="qr_code.checked"
                >15天内自动登录</el-checkbox
              >
            </el-form-item>
          </el-form>
          <div tag="div" class="phome_div4">
            还没有账号？<a @click="registeredT">立即注册</a>
          </div>
        </div>
      </transition>
      <!-- registered_password end -->
    </div>
    <!-- login-right end -->
  </div>
</template>
<script>
import myCaptcha from "@/common/js/myCaptcha";
import urlObj from "@/api/baseUrl";
import { set } from "vue";
export default {
  inject: ["reload"],
  data() {
    return {
      logintc: false,
      // 免密登录
      Avoid_close_login: true,
      Password_to_login: false,
      Retrieve_password: false,
      Phone_registered: false,
      Qr_code: false,
      dis: true,
      qq_hover: false,
      wx_hover: false,
      getCodes: "获取验证码",
      yz_count: "",
      yz_timer: null,
      dis2: true,
      rules: {
        phone: [
          {
            required: true,
            message: "电话号码不能为空",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          }
        ],
        againPassword: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          }
        ]
      },
      // 区号
      countryCodeList: [],
      // 免密登录
      avoid: {
        area_code: 86,
        phone: "",
        code: "",
        checked: false,
        phoneErrorMsg: "",
        isAgree:false,
        isRead:false,
      },
      // 密码登陆
      passwords: {
        phone: "",
        password: "",
        area_code: 86,
        checked: false
      },
      // 找回密码
      retrieves: {
        phone: "",
        code: "",
        password: "",
        area_code: 86,
        phoneErrorMsg: "",
        againPassword: ""
      },
      psdForm: {
        password: "",
        phoneErrorMsg: "",
        againPassword: ""
      },
      // 手机号快速注册
      registereds: {
        area_code: 86,
        phone: "",
        code: "",
        password: "",
        checked: false,
        phoneErrorMsg: "",
        againPassword: ""
      },
      qr_code: {
        checked: false
      },
      ewm: "",
      disabled_click_code: false,
      formIndex: 0,

      findPsdStatus: 0,
      verificationCodes: ["", "", "", "", "", ""],
      disabledBtn: false
    };
  },
  methods: {
    backLogin() {
      this.verificationCodes = ["", "", "", "", "", ""];
      this.retrieves = {
        phone: "",
        code: "",
        password: "",
        area_code: 86,
        phoneErrorMsg: "",
        againPassword: ""
      };
      this.psdForm = {
        password: "",
        phoneErrorMsg: "",
        againPassword: ""
      };
      this.findPsdStatus = 0;
      this.Password_to_login = true;
    },
    resetPsd(index) {
      if (this.disabledBtn) return;
      let { password, againPassword } = this[index];
      if (password != againPassword) {
        this.$message.error("两次密码不一致");
        return;
      }
      let mobileCode = this.verificationCodes.join("");
      this.$refs[index].validate(valid => {
        if (valid) {
          this.disabledBtn = true;
          this.$http
            .post(
              urlObj.passport + "ChangePassword",
              {
                areaCode: this.retrieves.area_code,
                mobile: this.retrieves.phone,
                passWord: password,
                mobileCode,
                systemPaaS: 6,
                paaSPort: 1
              },
              {
                headers: {
                  token: this.$cookies.get("token"),
                  Authorization: "Bearer " + this.$cookies.get("token")
                }
              }
            )
            .then(response => {
              if (response.data.succ) {
                this.$cookies.remove("token");
                this.findPsdStatus = 4;
              } else {
                this.$message.error(response.data.msg);
              }
              this.disabledBtn = false;
            })
            .catch(error => {
              this.$message.error(error);
              this.disabledBtn = false;
            });
        } else {
          return false;
        }
      });
    },
    stopInterVal() {
      clearInterval(this.yz_timer);
      this.yz_timer = null;
      setTimeout(() => {
        this.yz_count = 0;
      }, 300);
    },
    psdNext(index) {
      if (this.disabledBtn) return;
      let code = this.verificationCodes.join("");
      if (this.verificationCodes.some(item => !item)) {
        this.$message.warning("请输入完整验证码");
        return;
      }
      this.disabledBtn = true;
      this.$http
        .post(
          urlObj.passport + "MobileCode/VerifyCode",
          {
            areaCode: this[index].area_code,
            mobile: this[index].phone,
            systemPaaS: 6,
            paaSPort: 1,
            codeType: 3,
            signName: "启德教育",
            code,
            isFailure: false
          },
          {
            headers: {
              token: this.$cookies.get("token")
            }
          }
        )
        .then(res => {
          console.log("res", res);
          if (res.data.succ) {
            this.stopInterVal();
            this.findPsdStatus = 3;
          } else {
            this.$message.error(res.data.msg);
          }
          this.disabledBtn = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.disabledBtn = false;
        });
    },
    resetGet() {
      this.verificationCodes = ["", "", "", "", "", ""];
      this.getCode("retrieves");
    },
    handleInput(index, event) {
      const value = event.target.value;

      this.verificationCodes[index] = value;

      // 判断是否输入完成
      if (this.verificationCodes.join("").length === 6) {
        const nextInput = event.target;
        if (nextInput) {
          this.$nextTick(() => {
            nextInput.blur();
          });
        }
      }

      // 自动跳到下一个输入框
      if (value && index < this.verificationCodes.length - 1) {
        const nextInput = event.target.nextElementSibling;
        if (nextInput) {
          this.$nextTick(() => {
            nextInput.focus();
          });
        }
      }
    },
    handleKeyDown(index, event) {
      // 处理删除操作
      if (event.key === "Backspace" && !event.target.value && index > 0) {
        const prevInput = event.target.previousElementSibling;
        if (prevInput) {
          this.$nextTick(() => {
            prevInput.focus();
          });
        }
      }
    },
    loginsqs() {
      this.logintc = true;
    },
    loginsq() {
      this.logintc = false;
      this.Avoid_close_login = true;
      this.Password_to_login = false;
      this.Retrieve_password = false;
      this.Phone_registered = false;
      this.Qr_code = false;
    },
    acl() {
      this.Avoid_close_login = true;
      this.Password_to_login = false;
      this.Retrieve_password = false;
    },
    ptl() {
      this.Avoid_close_login = false;
      this.Password_to_login = true;
      this.Retrieve_password = false;
    },
    retrieveT() {
      if (this.passwords.phone) {
        this.retrieves.phone = this.passwords.phone;
      }
      this.Password_to_login = false;
      this.findPsdStatus = 1;
    },
    registeredT() {
      this.Avoid_close_login = false;
      this.Password_to_login = false;
      this.Phone_registered = true;
    },
    qr_codeT(index) {
      // console.log(index)
      if (index == 1) {
        this.ewm = true;
      } else {
        this.ewm = false;
      }
      this.Password_to_login = false;
      this.Avoid_close_login = false;
      this.Phone_registered = false;
      this.Qr_code = true;
    },
    back() {
      if (this.findPsdStatus == 1) {
        this.findPsdStatus = 0;
        this.Password_to_login = true;
        return;
      } else if (this.findPsdStatus == 2) {
        this.stopInterVal();
        this.verificationCodes = ["", "", "", "", "", ""];
        this.findPsdStatus = 1;
        return;
      } else if (this.findPsdStatus == 3) {
        this.findPsdStatus = 2;
        this.verificationCodes = ["", "", "", "", "", ""];
        return;
      }
      this.Avoid_close_login = true;
      this.Password_to_login = false;
      this.Retrieve_password = false;
      this.Qr_code = false;
      this.Phone_registered = false;
    },
    // 免密登录
    loginForm(formName) {
      var that = this;
      var phone = this.avoid.phone;
      var code = this.avoid.code;
      var areaCode = this.avoid.area_code;
      console.log(this.avoid);
      that.$refs[formName].model.phoneErrorMsg = "";
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(areaCode==1&&(!this.avoid.isAgree||!this.avoid.isRead)){
            that.$message.error('请阅读勾选协议');
          }else{
            this.$http
            .post("https://schoolapi.eiceducation.com.cn/api/Login", {
              LoginName: phone,
              MobileCode: code,
              AreaCode: areaCode,
              Type: 2,
              Source: "string"
            })
            .then(function(response) {
              // // console.log(response)
              if (response.data.code == 200) {
                that.$message({
                  message: "恭喜你，登录成功！",
                  type: "success"
                });
                let tokenkey = response.data.results.token;
                that.UserInfo(tokenkey);
                that.Messages(tokenkey);
                if (that.avoid.checked) {
                  that.$cookies.set(
                    "token",
                    response.data.results.token,
                    "15d"
                  );
                } else {
                  that.$cookies.set("token", response.data.results.token);
                }
                that.loginsq();
                console.log(
                  "that.$parent.$parent.$parent",
                  that.$parent.$parent.$parent
                );
                // 重新加载
                that.$parent.$parent.$parent.reload();

                that.$parent.headerToken = true;
              } else if (response.data.code == 500) {
                that.$refs[formName].model.phoneErrorMsg = response.data.msg;
              } else {
                that.$message.error(response.data.msg);
              }
            })
            .catch(function(error) {
              // console.log(error);
              that.$message.error(error);
            });
          }
       
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 密码登录
    passwordsForm(formName) {
      var that = this;
      var phone = this.passwords.phone;
      var password = this.passwords.password;
      var areaCode = this.passwords.area_code;
      that.$refs[formName].model.phoneErrorMsg = "";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post("https://schoolapi.eiceducation.com.cn/api/Login", {
              LoginName: phone,
              PassWord: password,
              AreaCode: areaCode,
              Type: 1,
              Source: "string"
            })
            .then(function(response) {
              console.log("response", response);
              if (response.data.code == 200) {
                that.$message({
                  message: "恭喜你，登录成功！",
                  type: "success"
                });
                let tokenkey = response.data.results.token;
                that.UserInfo(tokenkey);
                that.Messages(tokenkey);
                if (that.passwords.checked) {
                  that.$cookies.set("token", tokenkey, "15d");
                } else {
                  that.$cookies.set("token", tokenkey);
                }
                //个人数据
                that.loginsq();
                // 重新加载
                that.$parent.$parent.$parent.reload();

                that.$parent.headerToken = true;
              } else if (response.data.code == 500) {
                that.$refs[formName].model.phoneErrorMsg = response.data.msg;
              } else {
                that.$message.error(response.data.msg);
              }
            })
            .catch(function(error) {
              // console.log(error);
              that.$message.error(error);
            });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 密码找回
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.$refs[formName].model.phoneErrorMsg = "";
          this.getCode("retrieves");
        } else {
          that.$refs[formName].model.phoneErrorMsg = "电话号码不能为空";
          return false;
        }
      });
    },
    // 其他登录hover
    qq_login_m() {
      this.qq_hover = true;
    },
    qq_login_v() {
      this.qq_hover = false;
    },
    wx_login_m() {
      this.wx_hover = true;
    },
    wx_login_v() {
      this.wx_hover = false;
    },
    async codeLogic(res) {
      const TIME_COUNT = 60;
      let index = this.formIndex;
      let that = this;
      console.log("回调了", res);
      this.$http
        .post(
          urlObj.passport + "MobileCode/SendSmsCode",
          {
            areaCode: that.$refs[index].model.area_code,
            mobile: that.$refs[index].model.phone,
            systemPaaS: 6,
            paaSPort: 1,
            codeType: 3,
            ticket: res.ticket,
            randstr: res.randstr,
            signName: "启德教育"
          },
          {
            headers: {
              token: this.$cookies.get("token")
            }
          }
        )
        .then(response => {
          console.log(response, "response");
          sessionStorage.setItem("codeType", 3);
          if (!response.data.succ) {
            that.$refs[index].model.phoneErrorMsg = response.data.msg;
            return;
          }
          this.yz_count = TIME_COUNT;
          if (this.findPsdStatus == 1) {
            this.findPsdStatus = 2;
          }
          this.getCodes = this.yz_count + "S后重新获取";
          this.disabled_click_code = true;
          this.yz_timer = setInterval(() => {
            if (this.yz_count > 0 && this.yz_count <= TIME_COUNT) {
              this.yz_count--;
              this.getCodes = this.yz_count + "S后重新获取";
            } else {
              this.getCodes = "重新获取验证码";
              clearInterval(this.yz_timer);
              this.yz_timer = null;
              this.disabled_click_code = false;
            }
          }, 1000);
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    // 验证码倒计时
    async getCode(index) {
      const TIME_COUNT = 60;
      let that = this;
      var phones = this.$refs[index].model.phone;
      var areaCode = this.$refs[index].model.area_code;
      that.$refs[index].model.phoneErrorMsg = "";

      let urls =
        "https://schoolapi.eiceducation.com.cn/api/Code?phone=" +
        phones +
        "&systemtype=1&areaCode=" +
        areaCode;
      let request = {};
      if (this.Avoid_close_login) {
        let result = await this.$http.get(
          `https://schoolapi.eiceducation.com.cn/api/IsExistPhone?phone=${phones}&areaCode=${areaCode}`,
          {
            headers: {
              token: this.$cookies.get("token"),
              Authorization: "Bearer " + this.$cookies.get("token")
            }
          }
        );
        if (!result.data.succ) {
          this.$message({
            message: "该手机号还没有注册，先去注册~",
            type: "error"
          });
          return;
        }
      }
      this.$refs[index].validateField("phone", valid => {
        if (!valid) {
          if (!this.yz_timer) {
            this.formIndex = index;
            myCaptcha(this.codeLogic);
          }
        } else {
          return false;
        }
      });
    },
    //手机号快速注册
    submitphone(formName) {
      var that = this;
      if (this.registereds.password != this.registereds.againPassword) {
        this.$message.error("两次密码不一致");
        return;
      }
      var phone = this.registereds.phone;
      var code = this.registereds.code;
      var password = this.registereds.password;
      var areaCode = this.registereds.area_code;
      that.$refs[formName].model.phoneErrorMsg = "";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post("https://schoolapi.eiceducation.com.cn/api/Register", {
              LoginName: phone,
              PassWord: password,
              AreaCode: areaCode,
              MobileCode: code,
              Source: "pc"
            })
            .then(function(response) {
              if (response.data.code == 200) {
                that.$message({
                  message: "恭喜你，注册成功！",
                  type: "success"
                });
                that.$cookies.set("token", response.data.results.token);
                let tokenkey = response.data.results.token;
                that.UserInfo(tokenkey);
                that.Messages(tokenkey);
                that.loginsq();
                // 重新加载
                that.$parent.$parent.$parent.reload();

                that.$parent.headerToken = true;
              } else if (response.data.code == 500) {
                that.$refs[formName].model.phoneErrorMsg = response.data.msg;
              } else {
                that.$message.error(response.data.msg);
              }
            })
            .catch(function(error) {
              // console.log(error);
              that.$message.error(error);
            });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 个人数据
    UserInfo(tokenkey) {
      var that = this;
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: tokenkey
          }
        })
        .then(function(result) {
          that.$parent.UserInfo = result.data.results;
          that.$parent.NickNam = result.data.results.NickName;
          if (result.data.results.HeadUrl) {
            that.$parent.HeadUrl = result.data.results.HeadUrl;
          }
          that.$parent.$parent.$parent.appUserInfo(tokenkey);
          if (tokenkey) {
            that.$store.commit("setUserInfo", result.data.results);
          } else {
            that.$store.commit("setUserInfo", { Type: 1 });
          }
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    },
    // 个人数据
    Messages(tokenkey) {
      var that = this;
      // 获取站内信
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/Messages?isRead=false",
          {
            headers: {
              token: tokenkey,
              Accept: "application/json"
            }
          }
        )
        .then(function(result) {
          // // console.log(result)
          if (result.data.results.length > 0) {
            that.$parent.messageL = result.data.results.length;
          } else {
            that.$parent.messageL = "";
          }
          that.$parent.messages = result.data.results.reverse();
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    //手机号码归属国家区号
    getCountryCodeList() {
      // console.log('123');
      this.$http
        .get("https://api-kt.eiceducation.com.cn/api/country/getCountryCodeList")
        .then(res => {
          // console.log(res)
          if (res.data.succ) {
            let codeList = [];
            codeList = res.data.results;
            this.countryCodeList = codeList;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted: function() {
    //自动触发写入的函数
    this.$bus.$on("loginShow", blone => {
      this.logintc = blone;
    });
    this.getCountryCodeList();
    // const s = document.createElement('script');
    // s.type = 'text/javascript';
    // s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    // document.body.appendChild(s);
    // var obj = new WxLogin({
    //   self_redirect: true,
    //   id: "login_container",
    //   appid: "",
    //   scope: "",
    //   redirect_uri: "",
    //   state: "",
    //   style: "",
    //   href: ""
    // });
  }
};
</script>

<style lang="less">
.login_box {
  width: 1000px;
  height: 700px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -350px;
  margin-left: -500px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(102, 102, 102, 0.6);
  background: #ffffff;
  z-index: 10;
  /* transform:scale(0.8,0.8); */
}

.Theight {
  height: 100%;
}

.close {
  position: absolute;
  right: 28px;
  top: 28px;
  cursor: pointer;
}

.jdt1 {
  width: 480px;
  height: 480px;
  position: absolute;
  left: 12px;
  top: 100px;
  .el-carousel__indicators {
    // 指示器
    left: unset;
    transform: unset;
    right: 2%;
  }
  .el-carousel__button {
    width: 36px;
    height: 6px;
    border-radius: 3px 3px 3px 3px;
  }
  .is-active .el-carousel__button {
    // 指示器激活按钮
    background: #337cff;
  }

  .el-carousel__container {
    height: 100%;
  }
}

.login-right {
  width: 440px;
  height: 600px;
  border-radius: 12px;
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  position: absolute;
  top: 80px;
  right: 30px;
  overflow: hidden;
}

.login-nav {
  width: 360px;
  height: 68px;
  margin: 0 auto;
  border-bottom: 2px #eaeaea solid;
  box-sizing: border-box;
  padding-top: 36px;
}

.login-nav li {
  float: left;
  height: 24px;
  margin-right: 28px;
  padding: 0 2px;
  display: block;
  color: #999;
  font-size: 20px;
  line-height: 24px;
  position: relative;
}

.login-nav li span {
  position: relative;
  z-index: 2;
  cursor: pointer;
}

/* 免密登录 */
.login-nav {
  margin-bottom: 48px;
}

.login-nav li.side {
  font-size: 20px;
  color: #333;
}

.login-nav li.side em {
  display: block;
  width: 80px;
  height: 5px;
  border-radius: 3px 3px 3px 3px;
  background: #ff0659;
  position: absolute;
  top: 28px;
  left: 0;
  z-index: 1;
}

#Avoid_close_login {
  padding: 0 40px;
}

.login_box .h2 {
  text-align: left;
  font-size: 24px;
  color: #333;
  line-height: 24px;
  margin-bottom: 13px;
  font-weight: normal;
}

.login_box .h3 {
  text-align: left;
  font-size: 16px;
  color: #666;
  line-height: 16px;
  margin-bottom: 20px;
  font-weight: normal;
}

.demo-avoid {
  margin-bottom: 50px;
}

.demo-avoid .mb40 {
  margin-bottom: 40px;
}

.demo-avoid .mb0 {
  margin-bottom: 0;
}

.demo-avoid .el-input__inner {
  height: 46px;
}

.demo-avoid .el-select .el-input {
  height: 44px;
  border-radius: 4px;
  background: #fff;
}

.demo-avoid .el-checkbox {
  line-height: 20px;
  float: left;
  text-align: left;
}

.demo-avoid .el-select .el-input .el-input__inner {
  width: 80px;
  height: 44px;
  border-radius: 4px;
  padding-right: 10px;
}

.demo-avoid .button1 {
  width: 100%;
  height: 46px;
  font-size: 16px;
  border-radius: 23px;
  background: #ff0659;
  border: none;
  color: #fff;
}

.demo-avoid .button2 {
  width: 100%;
  height: 46px;
  font-size: 14px;
  padding: 0;
}

.phome_div4 {
  height: 16px;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
  text-align: left;
  margin-bottom: 10px;
}

.phome_div4 a {
  color: #337cff;
  cursor: pointer;
}

.phome_div4 a:hover {
  text-decoration: underline;
}

.phome_div4 a:nth-child(2) {
  color: #999999;
  float: right;
}

.qt_login p {
  height: 16px;
  margin-bottom: 20px;
}

.qt_login span {
  padding: 0 16px;
  font-size: 16px;
  color: #666666;
  line-height: 16px;
  text-align: center;
  float: left;
}

.qt_login em {
  display: block;
  width: 116px;
  height: 1px;
  background: #d5d5d5;
  border-radius: 2px;
  float: left;
  margin-top: 8px;
}

.qt_login ul li {
  width: 42px;
  height: 42px;
  margin: 0 14px;
  display: inline-block;
}

.qt_login ul li a {
  width: 42px;
  height: 42px;
  display: block;
}

.qt_login ul li.qq_login a {
  background: url(../assets/login/icon_QQ_Default.png) no-repeat;
}

.qt_login ul li.qq_login a.hovers {
  background: url(../assets/login/icon_QQ_Selected2.png) no-repeat;
}

.qt_login ul li.wx_login a {
  background: url(../assets/login/icon_WeChat_Default.png) no-repeat;
}

.qt_login ul li.wx_login a.hovers {
  background: url(../assets/login/icon_WeChat_Selected2.png) no-repeat;
}

#Password_to_login {
  padding: 0 40px;
}

#Retrieve_password {
  padding: 45px 40px;
}
.icon_back {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 2px solid #d8d8d8;
  margin-bottom: 30px;
  cursor: pointer;
  .back_img {
    height: 24px;
    width: 24px;
    background: url(../assets/login/right_drop.png) left no-repeat;
    margin-right: 10px;
  }
  .back_val {
    font-size: 20px;
    color: #333333;
  }
}

#Phone_registered {
  padding: 45px 40px;
}

#Phone_registered .el-checkbox__input {
  float: left;
  margin-top: 3px;
}

#Phone_registered .el-checkbox__label {
  float: left;
}

#Phone_registered .el-form-item__content a {
  line-height: 20px;
  float: left;
  color: #337cff;
  cursor: pointer;
}

#Phone_registered .el-form-item__content a:last-child {
  margin-left: 20px;
}

#Phone_registered .el-form-item__content a:hover {
  text-decoration: underline;
}

#Qr_code {
  padding: 45px 40px;
  text-align: center;
}

#Qr_code h2 {
  text-align: center;
}

#Qr_code h3 {
  font-size: 12px;
  text-align: center;
}

#Qr_code .demo-avoid {
  margin-bottom: 22px;
}

#Qr_code .demo-avoid .el-checkbox {
  float: none;
}

#Qr_code .el-form-item__content {
  text-align: center;
  line-height: 50px;
}

#Qr_code .phome_div4 {
  text-align: center;
}
.my_checkbox {
  .el-checkbox__input {
    background: url("~@/assets/login/radio.png") no-repeat;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    margin-bottom: 1px;
    &.is-checked {
      background: url("~@/assets/login/radio_active.png") no-repeat;
      width: 16px;
      height: 16px;
      background-size: 100% 100%;
    }
    .el-checkbox__inner {
      display: none;
    }
  }
  .el-checkbox__label {
    color: #666666 !important;
    padding-left: 5px;
  }
}
.psd_view {
  .forget_psd {
    font-weight: 400;
    font-size: 12px;
    color: #337cff;
    line-height: 17px;
    text-align: right;
    font-style: normal;
    text-decoration-line: underline;
    text-transform: none;
    margin-top: -10px;
    cursor: pointer;
  }
  .my_checkbox {
    margin: 11px 0 13px;
  }
  .demo-avoid {
    margin-bottom: 0;
  }
}
.login_box {
  .find_psd {
    h2 {
      margin-bottom: 30px;
    }
    .button_default {
      width: 150px;
      height: 40px;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #d8d8d8;
    }
    .my_ipone {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
      margin-top: -26px;
    }
    &.set_psd {
      .demo-avoid {
        margin: 30px 0;
        .mb0 {
          margin-bottom: 20px;
          &:nth-child(2) {
            margin-bottom: 30px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.verificatio_code {
  margin: 30px 0;
  .verification-container {
    display: flex;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      display: block;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
      width: 26px;
      height: 2px;
      background: #d8d8d8;
      border-radius: 2px;
    }
    .verification-input {
      width: 45px;
      height: 45px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #999999;
      margin-right: 8px;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      &:nth-child(3) {
        margin-right: 58px;
      }
      &:last-child {
        margin-right: 0;
      }
    }

    .verification-input:focus {
      outline: none;
      border-color: #007bff;
      // box-shadow: 0 0 5px #007bff;
    }
  }
}
.code_count {
  font-weight: 400;
  font-size: 16px;
  margin-top: 10px;
  line-height: 23px;
  color: rgba(102, 102, 102, 1);
  span {
    color: #ff0659;
  }
}
.next_btn {
  cursor: pointer;
  width: 150px;
  background: #ff0659;
  border-radius: 6px 6px 6px 6px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}
.success_psd {
  padding: 107px 133px;
  box-sizing: border-box;
  .set_success {
    display: flex;
    flex-direction: column;
    align-items: center;
    .success_icon {
      width: 173px;
      height: 173px;
    }
    .back_login {
      margin-top: 84px;
      color: #fff;
      width: 150px;
      height: 40px;
      background: #ff0659;
      border-radius: 6px 6px 6px 6px;
      border: none;
    }
  }
}
.registration_btn {
  width: 100%;
  border-radius: 23px 23px 23px 23px;
  border: 1px solid #d8d8d8;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.agree_view {
  margin: 5px 0 11px;
  .eng_text {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 18px;
  }
}
.eng_checkbox {
  margin: 6px 0;
  .el-form-item__content {
    line-height: 1;
  }
  a {
    color: rgba(51, 124, 255, 1);
  }
  .nav_agree {
    color: rgba(51, 124, 255, 1);
    padding-left: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue